import { render, staticRenderFns } from "./ContractsAndGovernmentPanel.vue?vue&type=template&id=b20f1bea&scoped=true&"
import script from "./ContractsAndGovernmentPanel.vue?vue&type=script&lang=ts&"
export * from "./ContractsAndGovernmentPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20f1bea",
  null
  
)

export default component.exports